import { canUseDOM } from 'exenv';
import Cookies from 'js-cookie';

const areCookiesEnabled = () => {
  if(!canUseDOM) return;
  const d = document;
  try {
    // Create test cookie
    d.cookie = 'cookietest=1';
    const result = d.cookie.indexOf('cookietest=') !== -1;
    // Delete test cookie
    d.cookie = 'cookietest=1; expires=Thu, 01-Jan-1970 00:00:01 GMT';
    return result
  } catch (e) {
    return false
  }
}

const getAllCookies = () => {
  return Cookies.get();
}

const getCookie = (name) => {
  return Cookies.get(name);
}

const setCookie = (name, value, options) => {
  Cookies.set(name, value);
}

const removeCookie = (name) => {
  Cookies.remove(name);
}

export {
  areCookiesEnabled,
  getAllCookies,
  getCookie,
  setCookie,
  removeCookie
};